import { Container } from "reactstrap";

//Common
import FormBackGround from "../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../common/Forms/FormHeader/FormHeader";
import DisplayData from "../common/DisplayData/DisplayData";

import ActionBar from "../common/ActionBar/ActionBar";

//App
import userApi from "../../app/model/api/userApi";
import { UserViewProps } from "../../types";
import { queryKeys } from "./constants";
import useComponentGeneralStyles from "../styles";
import { getLookupValue } from "../../utility/helpers";
import { useQuery } from "@tanstack/react-query";

const ProfileView = (props: UserViewProps) => {
  const { onClose, editAction, initialVal } = props;
  const generalStyles = useComponentGeneralStyles();
  const { data: userLookupData } = useQuery({
    queryKey: [queryKeys.getUserLookups],
    queryFn: () => userApi.getLookups(),
  });
  let lookupOptions: any = [];
  if (userLookupData?.result) {
    lookupOptions = userLookupData?.result?.map((item: any) => ({
      id: item.id,
      display: item.name,
    }));
  }

  const roleId = initialVal?.roleId?.toString();

  return (
    <FormBackGround>
      <FormHeader
        title="View Profile"
        onClose={onClose}
        editActionHandler={editAction}
      />
      <Container>
        <DisplayData text="User Name" importedData={initialVal?.userName} />
        <DisplayData text="First Name" importedData={initialVal?.firstName} />
        <DisplayData text="Last Name" importedData={initialVal?.lastName} />
        <DisplayData
          text="Phone Number"
          importedData={initialVal?.phoneNumber}
        />
        <DisplayData
          text="Role"
          importedData={getLookupValue(roleId, lookupOptions)}
        ></DisplayData>
      </Container>
      <Container style={generalStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default ProfileView;
